import React, { useEffect, useMemo, useState } from 'react';
import './navbar.scss';
import { useLocation } from 'react-router-dom';
import { Dropdown } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import logo from './../../Assets/Images/logo.png';
import { getNotfication } from '../../module/features/Artist';
import NotificationBell from '../NotificationBell/NotificationBell';
import ArtistTopbarUserMenu from './ArtistTopbarUserMenu';

const PAGE_META = {
  '/dashboard': { eyebrow: 'Overview', title: 'Dashboard' },
  '/dashboard/view-campaigns': { eyebrow: 'Campaigns', title: 'All campaigns' },
  '/dashboard/drafts': { eyebrow: 'Campaigns', title: 'Drafts' },
  '/dashboard/billing': { eyebrow: 'Account', title: 'Billing' },
  '/dashboard/account-overview': { eyebrow: 'Account', title: 'Account overview' },
  '/dashboard/complete-profile': { eyebrow: 'Account', title: 'Edit profile' },
};

function getPageMeta(pathname) {
  if (pathname.startsWith('/create-campaign')) {
    return { eyebrow: 'Campaigns', title: 'New campaign' };
  }
  return PAGE_META[pathname] || { eyebrow: 'Overview', title: 'Dashboard' };
}

function Navbar({ hideLogo }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const [newNotification, setNewNotification] = useState(false);
  const campaigns = useSelector(e => e.artistSlice.campaigns);
  const notification = useSelector(e => e.artistSlice.notification);
  const user = useSelector(e => e.authenticationSlice.user);
  const auth0User = useSelector(e => e.authenticationSlice.auth0User);
  const isAdmin = useSelector(e => e.authenticationSlice.isAdmin);
  const [items, setItems] = useState([]);

  const pageMeta = useMemo(() => getPageMeta(location.pathname), [location.pathname]);

  const isArtist =
    user?.role === 'artist' || user?.user_type === 'artist' || (auth0User && !isAdmin);

  useEffect(() => {
    dispatch(getNotfication());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setNewNotification(notification);
  }, [notification]);

  useEffect(() => {
    if (campaigns) {
      const arr = campaigns?.map((a, i) => ({
        label: (
          <div className="notificationBox">
            <div className="innerNotificationBox">
              Your campaign has been submitted. Please check the email you added to keep track of
              the progress.
            </div>
          </div>
        ),
        key: i,
      }));
      setItems(arr);
    }
  }, [campaigns]);

  return (
    <div className={`MonetizingHeader ${!hideLogo ? 'campaingSideBar' : 'app-topbar'}`}>
      <div className={hideLogo ? 'app-topbar-inner' : 'innerMonetizingHeader'}>
        {!hideLogo && (
          <button
            type="button"
            className="logoButton"
            aria-label="Go to home"
            onClick={() => {
              window.location.href = '/';
            }}
          >
            <img className="logoImage" src={logo} alt="logo" />
          </button>
        )}

        {hideLogo ? (
          <div className="app-topbar-brand">
            {user && Object.keys(user).length ? (
              <div className="app-topbar-title">
                <p className="app-topbar-eyebrow">{pageMeta.eyebrow}</p>
                <p className="app-topbar-heading">{pageMeta.title}</p>
              </div>
            ) : null}
          </div>
        ) : null}

        {user && Object.keys(user).length ? (
          <div className={hideLogo ? 'app-topbar-actions' : 'notificationIcon'}>
            {isArtist && !isAdmin ? (
              <>
                <NotificationBell />
                {hideLogo ? <ArtistTopbarUserMenu /> : null}
              </>
            ) : (
              <Dropdown
                overlayClassName="dropdownSideBar notiDropDown"
                menu={{
                  items,
                }}
                trigger={['click']}
                onOpenChange={() => {
                  localStorage.removeItem('notification');
                  dispatch(getNotfication());
                }}
              >
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a onClick={e => e.preventDefault()}>
                  <svg
                    width="39"
                    height="39"
                    viewBox="0 0 39 39"
                    fill="var(--sp-ink)"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.5344 13.1872C20.108 13.1679 20.5572 12.6976 20.5374 12.1367C20.5177 11.5759 20.0367 11.1369 19.4629 11.1561L19.5344 13.1872ZM13.2042 18.9066L12.1652 18.9377C12.1656 18.9497 12.1661 18.9616 12.1669 18.9735L13.2042 18.9066ZM11.4299 23.5361L12.1085 24.3057C12.1271 24.2902 12.1451 24.2739 12.1625 24.257L11.4299 23.5361ZM10.8218 24.0279L11.4324 24.8503C11.4495 24.8381 11.4663 24.8253 11.4827 24.8122L10.8218 24.0279ZM16.796 27.2903C17.3701 27.2903 17.8355 26.8354 17.8355 26.2742C17.8355 25.713 17.3701 25.2581 16.796 25.2581V27.2903ZM19.5344 11.1561C18.9606 11.1369 18.4795 11.5759 18.4597 12.1367C18.44 12.6976 18.8891 13.1679 19.4629 13.1872L19.5344 11.1561ZM25.793 18.9066L26.8303 18.9734C26.8311 18.9615 26.8316 18.9497 26.8321 18.9377L25.793 18.9066ZM27.5673 23.5347L26.8347 24.2556C26.8522 24.2724 26.8702 24.2888 26.8887 24.3044L27.5673 23.5347ZM28.1755 24.0265L27.5145 24.8108C27.5306 24.8237 27.5469 24.8362 27.5637 24.8481L28.1755 24.0265ZM22.2013 25.2581C21.6272 25.2581 21.1618 25.713 21.1618 26.2742C21.1618 26.8354 21.6272 27.2903 22.2013 27.2903V25.2581ZM18.4591 12.1717C18.4591 12.7329 18.9246 13.1878 19.4986 13.1878C20.0727 13.1878 20.5381 12.7329 20.5381 12.1717H18.4591ZM20.5381 10.0161C20.5381 9.45494 20.0727 9 19.4986 9C18.9246 9 18.4591 9.45494 18.4591 10.0161H20.5381ZM16.796 25.2581C16.2219 25.2581 15.7565 25.713 15.7565 26.2742C15.7565 26.8354 16.2219 27.2903 16.796 27.2903V25.2581ZM22.2013 27.2903C22.7753 27.2903 23.2407 26.8354 23.2407 26.2742C23.2407 25.713 22.7753 25.2581 22.2013 25.2581V27.2903ZM17.8355 26.2742C17.8355 25.713 17.3701 25.2581 16.796 25.2581C16.2219 25.2581 15.7565 25.713 15.7565 26.2742H17.8355ZM23.2407 26.2742C23.2407 25.713 22.7753 25.2581 22.2013 25.2581C21.6272 25.2581 21.1618 25.713 21.1618 26.2742H23.2407ZM19.4629 11.1561C15.2747 11.297 12.0353 14.8014 12.1652 18.9377L14.2431 18.8754C14.1469 15.8096 16.5396 13.2879 19.5344 13.1872L19.4629 11.1561ZM12.1669 18.9735C12.2643 20.4142 11.7229 21.8192 10.6973 22.8152L12.1625 24.257C13.621 22.8405 14.3778 20.8584 14.2414 18.8397L12.1669 18.9735ZM10.7513 22.7664C10.5341 22.9493 10.3516 23.0901 10.1609 23.2436L11.4827 24.8122C11.6352 24.6893 11.8689 24.5076 12.1085 24.3057L10.7513 22.7664ZM10.2112 23.2055C9.9073 23.4212 9.63116 23.7293 9.42531 24.0546C9.22202 24.3757 9.02751 24.808 9.0026 25.2862C8.97533 25.8093 9.15967 26.3911 9.70728 26.8004C10.1972 27.1668 10.8428 27.2903 11.5258 27.2903V25.2581C11.2994 25.2581 11.1497 25.2364 11.0578 25.2135C10.9668 25.1909 10.9506 25.1715 10.9702 25.1861C10.9956 25.2052 11.0333 25.2456 11.0581 25.3037C11.0807 25.3567 11.0788 25.3914 11.0789 25.3898C11.0791 25.3858 11.0818 25.3574 11.1016 25.304C11.1209 25.2518 11.1514 25.1899 11.1932 25.1239C11.2348 25.0582 11.282 24.9971 11.3289 24.9462C11.377 24.8936 11.4145 24.8629 11.4324 24.8503L10.2112 23.2055ZM11.5258 27.2903H16.796V25.2581H11.5258V27.2903ZM19.4629 13.1872C22.4577 13.2879 24.8503 15.8096 24.7541 18.8754L26.8321 18.9377C26.9619 14.8014 23.7225 11.297 19.5344 11.1561L19.4629 13.1872ZM24.7559 18.8398C24.6199 20.8581 25.3766 22.8395 26.8347 24.2556L28.2999 22.8138C27.2746 21.8181 26.7332 20.4137 26.8303 18.9734L24.7559 18.8398ZM26.8887 24.3044C27.1284 24.5063 27.3621 24.6879 27.5145 24.8108L28.8363 23.2422C28.6456 23.0887 28.4631 22.9479 28.2459 22.765L26.8887 24.3044ZM27.5637 24.8481C27.5823 24.8612 27.6203 24.8925 27.6688 24.9455C27.716 24.997 27.7637 25.0584 27.8057 25.1245C27.8478 25.1909 27.8786 25.2531 27.8981 25.3055C27.9181 25.3591 27.921 25.3877 27.9212 25.3915C27.9213 25.3931 27.9192 25.3581 27.9419 25.3047C27.9669 25.2459 28.005 25.2052 28.0306 25.186C28.0503 25.1712 28.0341 25.1906 27.9426 25.2134C27.8503 25.2364 27.6999 25.2581 27.4728 25.2581V27.2903C28.1565 27.2903 28.8029 27.1669 29.2931 26.8005C29.8418 26.3906 30.0256 25.8077 29.9972 25.2842C29.9713 24.8057 29.7757 24.3736 29.5721 24.0528C29.3659 23.7279 29.0898 23.4204 28.7871 23.2049L27.5637 24.8481ZM27.4728 25.2581H22.2013V27.2903H27.4728V25.2581ZM20.5381 12.1717V10.0161H18.4591V12.1717H20.5381ZM16.796 27.2903H22.2013V25.2581H16.796V27.2903ZM15.7565 26.2742C15.7565 28.3075 17.4072 30 19.4986 30V27.9677C18.6047 27.9677 17.8355 27.234 17.8355 26.2742H15.7565ZM19.4986 30C21.5899 30 23.2407 28.3075 23.2407 26.2742H21.1618C21.1618 27.234 20.3924 27.9677 19.4986 27.9677V30Z"
                      fill="var(--sp-ink)"
                    />
                    {newNotification ? <circle cx="27.5" cy="14.5" r="5.5" fill="var(--sp-blue)" /> : null}
                  </svg>
                </a>
              </Dropdown>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Navbar;
